<div class="dialog">
  <div class="storage-alert">
    <app-svg src="/assets/icons/storage-alert.svg"></app-svg>
  </div>

  <h1>Out of Storage</h1>
  <p>
    This upload would exceed your storage capacity by <b>{{ over() | dataUnitsBigInt: 1 }}</b
    >. Free up some space by deleting older galleries or add more storage.
  </p>

  <a
    [routerLink]="'/a/settings/storage'"
    appButton
    name="add-storage"
    location="out-of-storage-dialog"
    (click)="close()"
    color="primary"
    height="4"
    shape="round"
    size="3"
    spacing="full"
    >Add Storage</a
  >
</div>
